import BaseAPIService from '@/services/baseAPIService'

export default class GlassProductionStationAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  // Station Actions
  runPanelBarcodeScan(stationId, data)          { return this.httpClient.post(`/production/stations/${stationId}/panels/scan`, data) }
  removePanelFromStation(stationId, data)       { return this.httpClient.post(`/production/stations/${stationId}/panels/removepanel`, data) }
  completePanelTasks(stationId, data)           { return this.httpClient.post(`/production/stations/${stationId}/panels/completetasks`, data) }
  recutPanel(stationId, data)                   { return this.httpClient.post(`/production/stations/${stationId}/panels/recut`, data) }
  updatePanelStationData(stationId, data)       { return this.httpClient.post(`/production/stations/${stationId}/panels/updatestationdata`, data) }
  updatePanelExportData(stationId, data)        { return this.httpClient.post(`/production/stations/${stationId}/panels/exportdata`, data) }
  updateStationProcessingData(stationId, data)  { return this.httpClient.post(`/production/stations/${stationId}/updatestationdata`, data) }
  updateStationScanOptions(stationId, data)     { return this.httpClient.put(`/production/stations/${stationId}/scanoptions`, data) }

  // Station - General barcode lookup
  runBarcodeLookup(stationId, barcode)          { return this.httpClient.get(`/production/stations/${stationId}/barcode/lookup?barcode=${encodeURIComponent(barcode)}`) }

  // Station - General Search
  performStationAppSearch(stationId, params = {}) {
    var queryString = `/production/stations/${stationId}/search?` + $.param(params)
    return this.httpClient.get(queryString)
  }

  // Station - Offcut Management
  getGlassLevel(stationId, glassLevelId)        { return this.httpClient.get(`/production/stations/${stationId}/glasslevels/${glassLevelId}`) }
  createGlassOffcut(stationId, data)            { return this.httpClient.post(`/production/stations/${stationId}/glasslevels`, data) }
  updateGlassLevel(stationId, glassLevelId, data)        { return this.httpClient.put(`/production/stations/${stationId}/glasslevels/${glassLevelId}`, data) }
  cutGlassLevel(stationId, glassLevelId, data)      { return this.httpClient.post(`/production/stations/${stationId}/glasslevels/${glassLevelId}/cut`, data) }
  createGlassLevelIssue(stationId, glassLevelId, data)  { return this.httpClient.post(`/production/stations/${stationId}/glasslevels/${glassLevelId}/issue`, data) }
  revertGlassLevelIssue(stationId, glassLevelId, data)  { return this.httpClient.post(`/production/stations/${stationId}/glasslevels/${glassLevelId}/revert`, data) }

  generatePrintOffcutLabelURL(stationId, glassLevelId, params = {}) {
    var exportURL = `/production/stations/${stationId}/glasslevels/${glassLevelId}/label?` + $.param(params)
    return this.httpClient.post(`/system/signedurl`, { path: `api/v1${exportURL}` })
  }
  
  // Station - Manual Cutting
  getCuttingLog(stationId, params = {}) { 
    var queryString = `/production/stations/${stationId}/cuttinglog?` + $.param(params)
    return this.httpClient.get(queryString)
  }
  revertCuttingLog(stationId, cuttingLogId)         { return this.httpClient.post(`/production/stations/${stationId}/cuttinglog/${cuttingLogId}/revert`) }
  runGlassBlockBarcodeLookup(stationId, barcode)    { return this.httpClient.get(`/production/stations/${stationId}/glassblocks/barcode/lookup?barcode=${encodeURIComponent(barcode)}`) }
  openGlassBlockCutSheet(stationId, glassBlockId, data) { return this.httpClient.post(`/production/stations/${stationId}/glassblocks/${glassBlockId}/opencutsheet`, data) }

  // Station - Assembly
  runAssemblyBarcodeScan(stationId, assemblyPanelId, data)  { return this.httpClient.post(`/production/stations/${stationId}/assemblies/${assemblyPanelId}/scan`, data) }
  removeAssemblyFromStation(stationId, assemblyPanelId)     { return this.httpClient.post(`/production/stations/${stationId}/assemblies/${assemblyPanelId}/remove`) }
  removeScannedItemFromAssembly(stationId, assemblyPanelId, data)     { return this.httpClient.post(`/production/stations/${stationId}/assemblies/${assemblyPanelId}/removescanned`, data) }

  // Station - Optimiser Cutting
  getSheetListAtStation(stationId)              { return this.httpClient.get(`/production/stations/${stationId}/optimisersheets`) }
  createSheet(stationId, data)                  { return this.httpClient.post(`/production/stations/${stationId}/optimisersheets`, data) }
  addSheetToStation(stationId, data)            { return this.httpClient.post(`/production/stations/${stationId}/optimisersheets/add`, data) }
  optimiseSheetQueue(stationId)                 { return this.httpClient.post(`/production/stations/${stationId}/optimisersheets/optimisequeue`) }
  removeSheetQueue(stationId)                   { return this.httpClient.post(`/production/stations/${stationId}/optimisersheets/removequeue`) }

  sendSheetToSecondary(stationId, sheetId)      { return this.httpClient.post(`/production/stations/${stationId}/optimisersheets/${sheetId}/sendsecondary`) }
  sendSheetToPrimary(stationId, sheetId)        { return this.httpClient.post(`/production/stations/${stationId}/optimisersheets/${sheetId}/sendprimary`) }
  removeSheetFromStation(stationId, sheetId)    { return this.httpClient.post(`/production/stations/${stationId}/optimisersheets/${sheetId}/remove`) }
  startCuttingSheet(stationId, sheetId, data)   { return this.httpClient.post(`/production/stations/${stationId}/optimisersheets/${sheetId}/startcutting`, data) }
  revertCuttingSheet(stationId, sheetId)        { return this.httpClient.post(`/production/stations/${stationId}/optimisersheets/${sheetId}/revertcutting`) }
  finishCuttingSheet(stationId, sheetId)        { return this.httpClient.post(`/production/stations/${stationId}/optimisersheets/${sheetId}/finishcutting`) }
  updateSheet(stationId, sheetId, data)         { return this.httpClient.put(`/production/stations/${stationId}/optimisersheets/${sheetId}`, data) }
  updateSheetLayout(stationId, sheetId, data)   { return this.httpClient.put(`/production/stations/${stationId}/optimisersheets/${sheetId}/layout`, data) }
  revertOptimiserSheetBarcode(stationId, sheetId, data) { return this.httpClient.post(`/production/stations/${stationId}/optimisersheets/${sheetId}/revertscan`, data) }
  addPanelsToOptimiserSheet(stationId, sheetId, data) { return this.httpClient.post(`/production/stations/${stationId}/optimisersheets/${sheetId}/addpanels`, data) }

  getOptimiserPanelDetails(stationId, panelId)  { return this.httpClient.get(`/production/stations/${stationId}/optimiser/panels/${panelId}`) }
  calculateOptimiserPanelTrim(stationId, panelId, data) { return this.httpClient.post(`/production/stations/${stationId}/optimiser/panels/${panelId}/calctrim`, data) }

  getOptimiserStockAllocStats(stationId)        { return this.httpClient.get(`/production/stations/${stationId}/optimiser/reports/stockstats`) }
  getOptimiserUnallocPanelsList(stationId, stockId) {
    let params = {
      stockId: stockId
    }
    var queryString = `/production/stations/${stationId}/optimiser/reports/unallocpanels?` + $.param(params)
    return this.httpClient.get(queryString)
  }
  startOptimiserBGProcess(stationId, data)      { return this.httpClient.post(`/production/stations/${stationId}/optimiser/process`, data) }

  runSheetOptimiserBarcodeScan(stationId, sheetId, data) { return this.httpClient.post(`/production/stations/${stationId}/optimisersheets/${sheetId}/scan`, data) }

  generateCuttingSheetPrintPanelLabelsURL(stationId, sheetId, params = {}) {
    var exportURL = `/production/stations/${stationId}/optimisersheets/${sheetId}/panellabels?` + $.param(params)
    return this.httpClient.post(`/system/signedurl`, { path: `api/v1${exportURL}` })
  }
  generateCuttingSheetPrintOffcutLabelsURL(stationId, sheetId, params = {}) {
    var exportURL = `/production/stations/${stationId}/optimisersheets/${sheetId}/offcutlabels?` + $.param(params)
    return this.httpClient.post(`/system/signedurl`, { path: `api/v1${exportURL}` })
  }
  generateCuttingSheetExportURL(stationId, sheetId, params = {}) {
    var exportURL = `/production/stations/${stationId}/optimisersheets/${sheetId}/export?` + $.param(params)
    return this.httpClient.post(`/system/signedurl`, { path: `api/v1${exportURL}` })
  }

  // Station Toughening
  createTougheningBatch(stationId, data)        { return this.httpClient.post(`/production/stations/${stationId}/tougheningbatch`, data) }
  advanceTougheningBed(stationId, data)         { return this.httpClient.post(`/production/stations/${stationId}/advancetoughening`, data) }

  // Station - Panel Revert
  getPanelRevertTasks(stationId, panelId) {
    let params = {
      productionPanelId: panelId
    }
    var queryString = `/production/stations/${stationId}/panels/reverttasks?` + $.param(params)
    return this.httpClient.get(queryString)
  }
  revertPanelTasks(stationId, data)             { return this.httpClient.post(`/production/stations/${stationId}/panels/reverttasks`, data) }
  
  // Schedule
  getPanelScheduleForStation(id, params = {}) {
    var queryString = `/production/stations/${id}/panels/schedule?` + $.param(params)
    return this.httpClient.get(queryString)
  }
  getOrderScheduleForStation(id, params = {}) {
    var queryString = `/production/stations/${id}/orders/schedule?` + $.param(params)
    return this.httpClient.get(queryString)
  }
  getFilteredPanelList(params = {}) {
    var queryString = `/production/panels?` + $.param(params)
    return this.httpClient.get(queryString)
  }
  getSheetScheduleForStation(id, params = {}) {
    var queryString = `/production/stations/${id}/optimisersheets/schedule?` + $.param(params)
    return this.httpClient.get(queryString)
  }

  // Reporting - Performance
  getProductionStationPerformance(id)           { return this.reportingHttpClient.get(`/production/stations/${id}/performance`) }
  getProductionStationStatsSummary(id)          { return this.reportingHttpClient.get(`/production/stations/${id}/stats`) }

  // Production Panels
  getProductionPanel(id)                        { return this.httpClient.get(`/production/panels/${id}`) }
  movePanel(id, data)                           { return this.httpClient.post(`/production/panels/${id}/move`, data) }

  // Optimiser Sheets
  getOptimiserSheet(id)                         { return this.httpClient.get(`/optimiser/sheets/${id}`) }
  getStationSheetConfig(stationId, sheetId)     { return this.httpClient.get(`/production/stations/${stationId}/optimisersheets/${sheetId}/config`) }

  // Production - Manual Cutting Batch
  getStationProductionBatch(id)                 { return this.httpClient.get(`/production/stations/${id}/productionbatch`) }
  updateStationProductionBatch(id, data)        { return this.httpClient.put(`/production/stations/${id}/productionbatch`, data) }
  startCuttingProductionBatch(id)               { return this.httpClient.post(`/production/stations/${id}/productionbatch/startcutting`) }
  revertCuttingProductionBatch(id)              { return this.httpClient.post(`/production/stations/${id}/productionbatch/revertcutting`) }
  scanStationProductionBatch(id, data)          { return this.httpClient.post(`/production/stations/${id}/productionbatch/scan`, data) }
  cancelStationProductionBatch(id, data)          { return this.httpClient.post(`/production/stations/${id}/productionbatch/cancel`, data) }
}
